import EmailSentForm from '../components/organism/forms/EmailSentForm'

const Email = () => <EmailSentForm />

export default Email
